import AuthArea from "../../components/AuthArea";
import RegisterForm from "../../forms/RegisterForm";

export default function Register() {
  return <AuthArea Form={RegisterForm} />;
}
